import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { ClienteItemResponse, ClientesQueryParams } from "../typings";

function useClientes(params: ClientesQueryParams) {
  return useQuery([`/v1/cliente`, params], async () => {
    const { data } = await axios.get<PaginateResult<ClienteItemResponse>>(
      `/v1/cliente`,
      {
        params,
      }
    );

    return data;
  });
}

export default useClientes;
